import { render, staticRenderFns } from "./WeeksShiftsManager.vue?vue&type=template&id=6f28c0c6"
import script from "./WeeksShiftsManager.vue?vue&type=script&lang=js"
export * from "./WeeksShiftsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports